import { Component, OnInit,ViewChild} from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';

declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

})
export class AppComponent implements OnInit {
  title = 'HIMS';

  constructor(private router: Router) {


    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        $("#globalSearch").val("");
      }
    });
  }

  ngOnInit() {
    $('.modal-dialog').draggable({
      "handle": ".modal-header,.modal-footer"
    });
    $('.modal').on('hidden.bs.modal', function () {
      $('.modal-dialog').attr('style', 'inset: unset')
    });
  }

}
